var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.5C7.94036 6.5 8.5 5.94036 8.5 5.25C8.5 4.55964 7.94036 4 7.25 4C6.55964 4 6 4.55964 6 5.25C6 5.94036 6.55964 6.5 7.25 6.5Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79 21L0 11.21V13.21C0 13.74 0.21 14.25 0.59 14.62L8.38 22.41C9.16 23.19 10.43 23.19 11.21 22.41L17.42 16.2C18.2 15.42 18.2 14.15 17.42 13.37L9.79 21Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 17.41C8.77 17.8 9.28 18 9.79 18C10.3 18 10.81 17.8 11.2 17.41L17.41 11.2C18.19 10.42 18.19 9.15 17.41 8.37L9.62 0.58C9.25 0.21 8.74 0 8.21 0H2C0.9 0 0 0.9 0 2V8.21C0 8.74 0.21 9.25 0.59 9.62L8.38 17.41ZM2 2H8.21L16 9.79L9.79 16L2 8.21V2Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note_icon.aa39f2f9519e68754fd0618800bdd62d.svg";
export { ForwardRef as ReactComponent };